"use client";

import React from 'react';
import Link from 'next/link';
import { ArrowLeft, Shield, Lock, Eye, Database, UserCheck, FileText } from 'lucide-react';

export default function PrivacyPolicyPage() {
  return (
    <div className="min-h-screen bg-slate-950">
      <div className="max-w-4xl mx-auto px-4 py-8">
        {/* Header */}
        <div className="mb-8">
          <Link href="/register" className="inline-flex items-center text-slate-400 hover:text-slate-200 transition-colors mb-6">
            <ArrowLeft className="h-4 w-4 mr-2" />
            Kayıt Sayfasına Dön
          </Link>

          <div className="bg-gradient-to-r from-green-900/20 to-blue-900/20 rounded-xl p-8 border border-green-500/20">
            <div className="flex items-center gap-4 mb-4">
              <div className="w-16 h-16 bg-gradient-to-br from-green-500 to-blue-600 rounded-full flex items-center justify-center">
                <Shield className="h-8 w-8 text-white" />
              </div>
              <div>
                <h1 className="text-3xl font-bold text-slate-100">Gizlilik Politikası</h1>
                <p className="text-slate-300 mt-2">Kişisel Verilerin Korunması ve İşlenmesi</p>
              </div>
            </div>

            <div className="bg-green-900/20 border border-green-700/50 rounded-lg p-4 mt-6">
              <div className="flex items-center gap-2 mb-2">
                <Lock className="h-5 w-5 text-green-400" />
                <span className="font-semibold text-green-200">KVKK Uyumluluğu</span>
              </div>
              <p className="text-green-100 text-sm">
                Son güncelleme: {new Date().toLocaleDateString('tr-TR')}.
                Bu politika, 6698 sayılı Kişisel Verilerin Korunması Kanunu (KVKK) uyarınca hazırlanmıştır.
              </p>
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="bg-slate-900 rounded-xl p-8 border border-slate-700 space-y-8">

          {/* Section 1: Veri Sorumlusu */}
          <section>
            <h2 className="text-xl font-bold text-slate-100 mb-4 flex items-center gap-2">
              <UserCheck className="h-5 w-5 text-blue-400" />
              1. VERİ SORUMLUSU
            </h2>
            <div className="text-slate-300 space-y-4">
              <p>6698 sayılı Kişisel Verilerin Korunması Kanunu ("KVKK") uyarınca, kişisel verilerinizin işlenmesinden sorumlu olan <strong>AXTROLOG</strong>'dur.</p>

              <div className="bg-slate-800 rounded-lg p-4 border border-slate-600">
                <h3 className="font-semibold text-slate-200 mb-2">İletişim Bilgileri:</h3>
                <ul className="space-y-1 text-sm">
                  <li>E-posta: kvkk@axtrolog.com</li>
                  <li>Telefon: 0850 xxx xx xx</li>
                  <li>Adres: [Şirket adresi buraya eklenecek]</li>
                </ul>
              </div>
            </div>
          </section>

          {/* Section 2: İşlenen Kişisel Veriler */}
          <section>
            <h2 className="text-xl font-bold text-slate-100 mb-4 flex items-center gap-2">
              <Database className="h-5 w-5 text-purple-400" />
              2. İŞLENEN KİŞİSEL VERİLER
            </h2>
            <div className="text-slate-300 space-y-6">

              <div className="bg-slate-800 rounded-lg p-6 border border-slate-600">
                <h3 className="font-semibold text-slate-200 mb-4">2.1 Kimlik ve İletişim Verileri:</h3>
                <ul className="list-disc pl-6 space-y-2">
                  <li><strong>Ad, Soyad:</strong> Hizmet kişiselleştirmesi ve kimlik doğrulama</li>
                  <li><strong>E-posta Adresi:</strong> Hesap yönetimi, bildirimler ve destek hizmetleri</li>
                  <li><strong>Telefon Numarası:</strong> Güvenlik doğrulaması ve acil bildirimler</li>
                  <li><strong>Cinsiyet:</strong> Astrolojik analiz kişiselleştirmesi</li>
                </ul>
              </div>

              <div className="bg-slate-800 rounded-lg p-6 border border-slate-600">
                <h3 className="font-semibold text-slate-200 mb-4">2.2 Doğum Bilgileri (Özel Nitelikli Veri):</h3>
                <div className="bg-amber-900/20 border border-amber-700/50 rounded-lg p-4 mb-4">
                  <div className="flex items-center gap-2 mb-2">
                    <Lock className="h-4 w-4 text-amber-400" />
                    <span className="text-sm font-semibold text-amber-200">Hassas Veri Uyarısı</span>
                  </div>
                  <p className="text-amber-100 text-xs">
                    Doğum bilgileri özel nitelikli kişisel veri olarak kabul edilir ve özel koruma altındadır.
                  </p>
                </div>
                <ul className="list-disc pl-6 space-y-2">
                  <li><strong>Doğum Tarihi:</strong> Astrolojik harita hesaplaması</li>
                  <li><strong>Doğum Saati:</strong> Detaylı astrolojik analiz</li>
                  <li><strong>Doğum Yeri Koordinatları:</strong> Coğrafi astroloji hesaplamaları</li>
                  <li><strong>Saat Dilimi:</strong> Doğru zaman hesaplamları</li>
                </ul>
              </div>

              <div className="bg-slate-800 rounded-lg p-6 border border-slate-600">
                <h3 className="font-semibold text-slate-200 mb-4">2.3 Teknik Veriler:</h3>
                <ul className="list-disc pl-6 space-y-2">
                  <li><strong>IP Adresi:</strong> Güvenlik ve sistem yönetimi</li>
                  <li><strong>Tarayıcı Bilgileri:</strong> Uyumluluk optimizasyonu</li>
                  <li><strong>Çerezler (Cookies):</strong> Kullanıcı deneyimi iyileştirme</li>
                  <li><strong>Oturum Verileri:</strong> Platform kullanım analizi</li>
                </ul>
              </div>

            </div>
          </section>

          {/* Section 3: Veri İşleme Amaçları */}
          <section>
            <h2 className="text-xl font-bold text-slate-100 mb-4 flex items-center gap-2">
              <Eye className="h-5 w-5 text-teal-400" />
              3. VERİ İŞLEME AMAÇLARI VE HUKUKİ SEBEPLERİ
            </h2>
            <div className="text-slate-300 space-y-4">

              <div className="overflow-x-auto">
                <table className="w-full text-sm border border-slate-600 rounded-lg">
                  <thead className="bg-slate-800">
                    <tr>
                      <th className="border border-slate-600 p-3 text-left text-slate-200">İşleme Amacı</th>
                      <th className="border border-slate-600 p-3 text-left text-slate-200">Hukuki Sebep (KVKK m.5)</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="border border-slate-600 p-3">Hesap oluşturma ve yönetimi</td>
                      <td className="border border-slate-600 p-3">Sözleşmenin kurulması/ifası</td>
                    </tr>
                    <tr className="bg-slate-800/30">
                      <td className="border border-slate-600 p-3">Astrolojik analiz üretimi</td>
                      <td className="border border-slate-600 p-3">Açık rıza + Sözleşme ifası</td>
                    </tr>
                    <tr>
                      <td className="border border-slate-600 p-3">Müşteri destek hizmetleri</td>
                      <td className="border border-slate-600 p-3">Meşru menfaat</td>
                    </tr>
                    <tr className="bg-slate-800/30">
                      <td className="border border-slate-600 p-3">Güvenlik ve dolandırıcılık önleme</td>
                      <td className="border border-slate-600 p-3">Meşru menfaat</td>
                    </tr>
                    <tr>
                      <td className="border border-slate-600 p-3">Yasal yükümlülüklerin yerine getirilmesi</td>
                      <td className="border border-slate-600 p-3">Hukuki yükümlülük</td>
                    </tr>
                    <tr className="bg-slate-800/30">
                      <td className="border border-slate-600 p-3">Pazarlama iletişimi</td>
                      <td className="border border-slate-600 p-3">Açık rıza (isteğe bağlı)</td>
                    </tr>
                  </tbody>
                </table>
              </div>

            </div>
          </section>

          {/* Section 4: Rıza Yönetimi */}
          <section>
            <h2 className="text-xl font-bold text-slate-100 mb-4">4. RIZA YÖNETİMİ VE HAKLAR</h2>
            <div className="text-slate-300 space-y-6">

              <div className="bg-blue-900/20 border border-blue-500/30 rounded-lg p-6">
                <h3 className="font-semibold text-blue-200 mb-4">4.1 Açık Rıza Gerektiren İşlemler:</h3>
                <ul className="list-disc pl-6 space-y-2 text-blue-100">
                  <li>Doğum bilgilerinizin astrolojik analizlerde kullanılması</li>
                  <li>E-posta ve SMS pazarlama iletişimi</li>
                  <li>Kişiselleştirilmiş içerik önerileri</li>
                  <li>Üçüncü parti entegrasyonlar</li>
                </ul>
              </div>

              <div className="bg-green-900/20 border border-green-500/30 rounded-lg p-6">
                <h3 className="font-semibold text-green-200 mb-4">4.2 KVKK m.11 Kapsamında Haklarınız:</h3>
                <ul className="list-disc pl-6 space-y-2 text-green-100">
                  <li><strong>Bilgi talep etme:</strong> Hangi verilerinizin işlendiğini öğrenme</li>
                  <li><strong>Erişim hakkı:</strong> Verilerinizin kopyasını alma</li>
                  <li><strong>Düzeltme hakkı:</strong> Yanlış verilerin düzeltilmesini isteme</li>
                  <li><strong>Silme hakkı:</strong> Verilerinizin silinmesini talep etme</li>
                  <li><strong>İtiraz etme:</strong> Veri işlemeye itiraz etme</li>
                  <li><strong>Rıza geri çekme:</strong> Verdiğiniz rızayı geri alma</li>
                  <li><strong>Taşınabilirlik:</strong> Verilerinizi başka platforma aktarma</li>
                </ul>
              </div>

            </div>
          </section>

          {/* Section 5: Veri Paylaşımı */}
          <section>
            <h2 className="text-xl font-bold text-slate-100 mb-4">5. VERİ PAYLAŞIMI VE AKTARIMI</h2>
            <div className="text-slate-300 space-y-4">

              <div className="bg-red-900/20 border border-red-500/30 rounded-lg p-4 mb-4">
                <div className="flex items-center gap-2 mb-2">
                  <Shield className="h-4 w-4 text-red-400" />
                  <span className="text-sm font-semibold text-red-200">Temel İlke</span>
                </div>
                <p className="text-red-100 text-sm">
                  AXTROLOG, kişisel verilerinizi <strong>asla satmaz, kiralamaz veya ticari amaçla paylaşmaz</strong>.
                </p>
              </div>

              <h3 className="font-semibold text-slate-200">5.1 Sınırlı Paylaşım Durumları:</h3>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>Hizmet Sağlayıcıları:</strong> Teknik altyapı, ödeme sistemleri (veri işleme sözleşmesi ile)</li>
                <li><strong>Yasal Zorunluluklar:</strong> Mahkeme kararı, savcılık talebi</li>
                <li><strong>Güvenlik:</strong> Dolandırıcılık tespit sistemleri</li>
                <li><strong>İş Devri:</strong> Şirket satışı/birleşmesi durumunda (bildirimli)</li>
              </ul>

              <h3 className="font-semibold text-slate-200 mt-6">5.2 Yurtdışı Veri Aktarımı:</h3>
              <div className="bg-slate-800 rounded-lg p-4 border border-slate-600">
                <p className="text-sm">
                  Teknik hizmetler için yurtdışındaki sunucular kullanılabilir. Bu durumda:
                </p>
                <ul className="list-disc pl-6 mt-2 space-y-1 text-sm">
                  <li>KVKK m.9 uyarınca yeterli koruma sağlanır</li>
                  <li>Veri Transfer Etki Değerlendirmesi yapılır</li>
                  <li>Şirket içi bağlayıcı kurallar uygulanır</li>
                </ul>
              </div>

            </div>
          </section>

          {/* Section 6: Veri Güvenliği */}
          <section>
            <h2 className="text-xl font-bold text-slate-100 mb-4">6. VERİ GÜVENLİĞİ TEDBİRLERİ</h2>
            <div className="text-slate-300 space-y-4">

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

                <div className="bg-slate-800 rounded-lg p-4 border border-slate-600">
                  <h3 className="font-semibold text-slate-200 mb-3 flex items-center gap-2">
                    <Lock className="h-4 w-4 text-blue-400" />
                    Teknik Güvenlik
                  </h3>
                  <ul className="list-disc pl-6 space-y-1 text-sm">
                    <li>SSL/TLS şifreleme</li>
                    <li>AES-256 veri şifreleme</li>
                    <li>Güvenli sunucu altyapısı</li>
                    <li>Düzenli güvenlik taraması</li>
                    <li>İki faktörlü doğrulama</li>
                  </ul>
                </div>

                <div className="bg-slate-800 rounded-lg p-4 border border-slate-600">
                  <h3 className="font-semibold text-slate-200 mb-3 flex items-center gap-2">
                    <Shield className="h-4 w-4 text-green-400" />
                    İdari Güvenlik
                  </h3>
                  <ul className="list-disc pl-6 space-y-1 text-sm">
                    <li>Personel eğitimi</li>
                    <li>Erişim kontrol sistemi</li>
                    <li>Veri işlem logları</li>
                    <li>Düzenli risk değerlendirmesi</li>
                    <li>Olay müdahale planı</li>
                  </ul>
                </div>

              </div>

              <div className="bg-orange-900/20 border border-orange-500/30 rounded-lg p-4">
                <h3 className="font-semibold text-orange-200 mb-2">Veri İhlali Bildirimi:</h3>
                <p className="text-orange-100 text-sm">
                  KVKK m.12 uyarınca, veri güvenliği ihlali durumunda 72 saat içinde Kişisel Verileri Koruma Kuruluna,
                  yüksek riskli durumlarda ise ayrıca etkilenen kişilere bildirim yapılır.
                </p>
              </div>

            </div>
          </section>

          {/* Section 7: Veri Saklama */}
          <section>
            <h2 className="text-xl font-bold text-slate-100 mb-4">7. VERİ SAKLAMA SÜRELERİ</h2>
            <div className="text-slate-300 space-y-4">

              <div className="overflow-x-auto">
                <table className="w-full text-sm border border-slate-600 rounded-lg">
                  <thead className="bg-slate-800">
                    <tr>
                      <th className="border border-slate-600 p-3 text-left text-slate-200">Veri Türü</th>
                      <th className="border border-slate-600 p-3 text-left text-slate-200">Saklama Süresi</th>
                      <th className="border border-slate-600 p-3 text-left text-slate-200">Hukuki Dayanak</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="border border-slate-600 p-3">Kimlik ve iletişim verileri</td>
                      <td className="border border-slate-600 p-3">Hesap aktif olduğu sürece</td>
                      <td className="border border-slate-600 p-3">Sözleşme ifası</td>
                    </tr>
                    <tr className="bg-slate-800/30">
                      <td className="border border-slate-600 p-3">Doğum bilgileri</td>
                      <td className="border border-slate-600 p-3">Rıza geri çekilene kadar</td>
                      <td className="border border-slate-600 p-3">Açık rıza</td>
                    </tr>
                    <tr>
                      <td className="border border-slate-600 p-3">İşlem kayıtları</td>
                      <td className="border border-slate-600 p-3">10 yıl</td>
                      <td className="border border-slate-600 p-3">Ticaret Kanunu</td>
                    </tr>
                    <tr className="bg-slate-800/30">
                      <td className="border border-slate-600 p-3">Pazarlama rıza kayıtları</td>
                      <td className="border border-slate-600 p-3">Rıza geri çekilene kadar</td>
                      <td className="border border-slate-600 p-3">İspat yükümlülüğü</td>
                    </tr>
                  </tbody>
                </table>
              </div>

            </div>
          </section>

          {/* Section 8: Çerezler */}
          <section>
            <h2 className="text-xl font-bold text-slate-100 mb-4">8. ÇEREZLER (COOKIES) POLİTİKASI</h2>
            <div className="text-slate-300 space-y-4">

              <p>5651 sayılı İnternet Ortamında Yapılan Yayınların Düzenlenmesi ve Bu Yayınlar Yoluyla İşlenen Suçlarla Mücadele Edilmesi Hakkında Kanun uyarınca çerez kullanımı:</p>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">

                <div className="bg-slate-800 rounded-lg p-4 border border-slate-600">
                  <h3 className="font-semibold text-slate-200 mb-3">Zorunlu Çerezler</h3>
                  <p className="text-sm mb-2">Rıza gerektirmez:</p>
                  <ul className="list-disc pl-6 space-y-1 text-sm">
                    <li>Oturum yönetimi</li>
                    <li>Güvenlik</li>
                    <li>Dil tercihi</li>
                    <li>Alışveriş sepeti</li>
                  </ul>
                </div>

                <div className="bg-slate-800 rounded-lg p-4 border border-slate-600">
                  <h3 className="font-semibold text-slate-200 mb-3">İsteğe Bağlı Çerezler</h3>
                  <p className="text-sm mb-2">Rıza gerektirir:</p>
                  <ul className="list-disc pl-6 space-y-1 text-sm">
                    <li>Google Analytics</li>
                    <li>Pazarlama çerezleri</li>
                    <li>Sosyal medya entegrasyonu</li>
                    <li>Reklam personalizasyonu</li>
                  </ul>
                </div>

              </div>

            </div>
          </section>

          {/* Section 9: Başvuru Yolları */}
          <section>
            <h2 className="text-xl font-bold text-slate-100 mb-4">9. KVKK HAKLARINIZI KULLANMA</h2>
            <div className="text-slate-300 space-y-4">

              <div className="bg-green-900/20 border border-green-500/30 rounded-lg p-6">
                <h3 className="font-semibold text-green-200 mb-4">Başvuru Yöntemleri:</h3>

                <div className="space-y-4">
                  <div>
                    <h4 className="font-medium text-green-100 mb-2">1. Elektronik Başvuru (Önerilen):</h4>
                    <ul className="list-disc pl-6 space-y-1 text-sm text-green-50">
                      <li>E-posta: kvkk@axtrolog.com</li>
                      <li>Platform içi destek sistemi</li>
                      <li>Güvenli mesajlaşma sistemi</li>
                    </ul>
                  </div>

                  <div>
                    <h4 className="font-medium text-green-100 mb-2">2. Yazılı Başvuru:</h4>
                    <ul className="list-disc pl-6 space-y-1 text-sm text-green-50">
                      <li>Posta/kargo ile şirket adresine</li>
                      <li>Noter aracılığıyla</li>
                      <li>Elden teslim (resmi saat içinde)</li>
                    </ul>
                  </div>
                </div>

                <div className="bg-slate-800 rounded-lg p-4 mt-4 border border-slate-600">
                  <h4 className="font-medium text-slate-200 mb-2">Başvuru Gereklilikler:</h4>
                  <ul className="list-disc pl-6 space-y-1 text-sm">
                    <li>Kimlik doğrulama (TC kimlik no, pasaport vb.)</li>
                    <li>Talep konusunun açık belirtilmesi</li>
                    <li>İletişim bilgileri</li>
                    <li>İmza (yazılı başvurularda)</li>
                  </ul>
                </div>

              </div>

              <div className="bg-blue-900/20 border border-blue-500/30 rounded-lg p-4">
                <h3 className="font-semibold text-blue-200 mb-2">Yanıt Süreleri:</h3>
                <ul className="list-disc pl-6 space-y-1 text-sm text-blue-100">
                  <li><strong>Normal başvurular:</strong> 30 gün içinde</li>
                  <li><strong>Karmaşık talepler:</strong> 60 güne kadar uzatılabilir</li>
                  <li><strong>Ücretsiz:</strong> Yılda ilk 5 başvuru</li>
                  <li><strong>Ret durumu:</strong> Gerekçeli yanıt + VKK'ya başvuru hakkı</li>
                </ul>
              </div>

            </div>
          </section>

          {/* Section 10: Güncelleme */}
          <section>
            <h2 className="text-xl font-bold text-slate-100 mb-4">10. POLİTİKA GÜNCELLEMELERİ</h2>
            <div className="text-slate-300 space-y-4">
              <ul className="list-disc pl-6 space-y-2">
                <li>Bu gizlilik politikası, yasal değişiklikler ve hizmet güncellemeleri nedeniyle değiştirilebilir</li>
                <li>Önemli değişiklikler e-posta ve platform bildirimi ile duyurulur</li>
                <li>Güncellemeler yayınlandığı tarihten itibaren geçerlidir</li>
                <li>Eski sürümler arşivlenir ve talep üzerine sağlanır</li>
              </ul>
            </div>
          </section>

          {/* Contact Information */}
          <section className="bg-slate-800 rounded-lg p-6 border border-slate-600">
            <h2 className="text-xl font-bold text-slate-100 mb-4">VERİ KORUMA GÖREVLISI İLETİŞİM</h2>
            <div className="text-slate-300 space-y-2">
              <p><strong>KVKK Uyum Birimi</strong></p>
              <p>E-posta: kvkk@axtrolog.com</p>
              <p>Telefon: 0850 xxx xx xx (dahili: 100)</p>
              <p>Posta Adresi: [Şirket adresi] - KVKK Birimi</p>
              <p>Çalışma Saatleri: Pazartesi-Cuma 09:00-17:00</p>
            </div>
          </section>

          {/* External Links */}
          <section className="bg-blue-900/20 border border-blue-500/30 rounded-lg p-6">
            <h2 className="text-xl font-bold text-blue-200 mb-4">YASAL ÇERÇEVE</h2>
            <div className="text-blue-100 space-y-2 text-sm">
              <p>Bu politika aşağıdaki mevzuat uyarınca hazırlanmıştır:</p>
              <ul className="list-disc pl-6 space-y-1">
                <li>6698 sayılı Kişisel Verilerin Korunması Kanunu</li>
                <li>KVKK Veri Sorumluları Sicili Hakkında Yönetmelik</li>
                <li>KVKK Silme, Yok Etme ve Anonim Hale Getirme Yönetmeliği</li>
                <li>5651 sayılı İnternet Kanunu</li>
                <li>6563 sayılı Elektronik Ticaret Kanunu</li>
              </ul>
            </div>
          </section>

        </div>

        {/* Footer */}
        <div className="mt-8 text-center space-y-4">
          <div className="flex flex-col md:flex-row gap-4 justify-center">
            <Link
              href="/kullanim-kosullari"
              className="inline-flex items-center px-6 py-3 bg-slate-800 hover:bg-slate-700 border border-slate-600 rounded-lg text-slate-300 hover:text-slate-100 transition-colors"
            >
              <FileText className="h-4 w-4 mr-2" />
              Kullanım Koşulları
            </Link>
            <Link
              href="/register"
              className="inline-flex items-center px-6 py-3 bg-gradient-to-r from-green-600 to-blue-600 hover:from-green-700 hover:to-blue-700 text-white font-semibold rounded-lg transition-all transform hover:scale-105 shadow-lg"
            >
              <ArrowLeft className="h-4 w-4 mr-2" />
              Kayıt Sayfasına Dön
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}